"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftVoterClient = exports.NFT_VOTER_ID = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
const nft_voter_1 = require("./nft_voter");
exports.NFT_VOTER_ID = new web3_js_1.PublicKey('GnftV5kLjd67tvHpNGyodwWveEKivz3ZWvvE3Z4xi2iw');
class NftVoterClient {
    constructor(program, devnet) {
        this.program = program;
        this.devnet = devnet;
    }
    static connect(provider, devnet, programId = exports.NFT_VOTER_ID) {
        return new NftVoterClient(new anchor_1.Program(nft_voter_1.IDL, programId, provider), devnet);
    }
}
exports.NftVoterClient = NftVoterClient;
//# sourceMappingURL=client.js.map